export const impresionBannerEspeciales = (dataLayer, { idUsuario=null, banner, apartado }) => {
	dataLayer?.push?.({
		'event': 'banners',
		'user-id': idUsuario,
		'banner': banner,
		'apartado': apartado
	});
	return true;
}

export const clickBannersEspeciales = (dataLayer, { idUsuario=null, banner, apartado }) => {
	dataLayer?.push?.({
		'event': 'click-banner',
		'user-id': idUsuario,
		'banner': banner,
		'apartado': apartado
	});
}